// extracted by mini-css-extract-plugin
export default {"cls1":"ModalError-cls1___6357c2f58ac92b1e658","cls2":"ModalError-cls2__e864c17bc9f172490632 ModalError-cls1___6357c2f58ac92b1e658"};